import React from "react";
import ButnotP from "../Styles/butnotP";
import '../Styles/Debt_form.css'
import RedditTextField from "./reddit-textfield";
import { IMaskInput } from 'react-imask';
import PropTypes from 'prop-types';
import ScrollDialog from "./Dialog";
import { publicFetch } from "../util/fetch";
import { Spinner } from "react-bootstrap";
import { MdOutlineDone } from "react-icons/md";
import consentPdf from '../documents/Согласие_на_обработку_узнать_задолженность.pdf';
import { Form, Modal } from "react-bootstrap";


const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
        <IMaskInput
            {...other}
            mask="+7 (000) 000-0000"
            definitions={{
                '#': /[1-9]/,
            }}
            inputRef={ref}
            lazy={false}
            onAccept={(value) => onChange({ target: { name: props.name, value } })}
            overwrite
        />
    );
});

TextMaskCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const DebtForm = () => {
    const [values, setValues] = React.useState({
        textmask: '',
        username: '',
        birthdate: '',
        contract: '',
    });
    const [checked, setChecked] = React.useState(false)
    const [checked2, setChecked2] = React.useState(false)
    const [debtSuccess, setDebtSuccess] = React.useState()
    const [debtError, setDebtError] = React.useState()
    const [debtLoading, setDebtLoading] = React.useState(false)
    const [showModal, setShowModal] = React.useState(false)

    // Ссылки из API — null если недоступны
    const [telegramUrl, setTelegramUrl] = React.useState(null)
    const [maxUrl, setMaxUrl] = React.useState(null)

    const handleChange = (event) => {
        setValues({ ...values, [event.target.name]: event.target.value });
    };

    const handleChange1 = (e) => {
        setValues({ ...values, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
        if (!checked) {
            setDebtError(`Необходимо ознакомиться с Политикой компании в отношении обработки персональных данных`)
            return false
        }
        if (!checked2) {
            setDebtError(`Необходимо дать согласие на обработку персональных данных`)
            return false
        }
        setDebtError('')
        return true
    }

    // Нажатие «Продолжить» → валидация → запрос API → модалка
    const handleContinueClick = async (e) => {
        e.preventDefault()
        if (!validateForm()) return

        try {
            setDebtLoading(true)

            const { data } = await publicFetch.post(`api/check-debtor`, {
                username:  values.username,
                birthdate: values.birthdate,
                textmask:  values.textmask,
                contract:  values.contract,
                pageId: 1
            })

            // Сохраняем ссылки (null если не пришли)
            setTelegramUrl(data.telegramUrl || null)
            setMaxUrl(data.maxUrl || null)
            setShowModal(true)
        } catch (error) {
            // При ошибке API — показываем только «Заказать звонок»
            setTelegramUrl(null)
            setMaxUrl(null)
            setShowModal(true)
        } finally {
            setDebtLoading(false)
        }
    }

    // «Заказать звонок» → отправка заявки на сервер
    const handleCallbackSubmit = async () => {
        setShowModal(false)
        const Credentials = {
            username:  values.username,
            birthdate: values.birthdate,
            textmask:  values.textmask,
            contract:  values.contract,
            pageId: 1
        }
        try {
            setDebtLoading(true)
            const { data } = await publicFetch.post(`api/formreqs`, Credentials)
            setDebtError('');
            setTimeout(() => {
                setDebtSuccess(data.message);
            }, 1100);
        } catch (error) {
            setDebtLoading(false);
            const { data } = error.response;
            setDebtError(data.message);
            setDebtSuccess('');
        }
    }

    // Открыть ссылку в новой вкладке и закрыть модалку
    const handleLinkRedirect = (url) => {
        setShowModal(false)
        window.open(url, '_blank')
    }

    const handleBackClick = () => {
        setDebtLoading(false)
        setDebtSuccess(!debtSuccess)
    }

    return (
        <div className='formGroupD'>

            {!debtSuccess ? (
                <div className="DebtFormContainer">
                    <label className="FormLabel">Узнайте о наличии задолженности в OOO ПКО «Экспресс Коллекшн»</label>
                    <form className='ECformD' onSubmit={handleContinueClick}>
                        <div>
                            <RedditTextField required id='username' value={values.username} type='text'
                                             label='Фамилия Имя Отчество' onChange={handleChange}
                                             InputLabelProps={{shrink: true}} variant='filled' name='username'/>
                        </div>
                        <div>
                            <RedditTextField required id='date' label='Дата рождения' value={values.birthdate}
                                             type='date' InputLabelProps={{shrink: true}} variant='filled'
                                             name='birthdate' onChange={handleChange}
                                             InputProps={{disableUnderline: true}}
                                             inputProps={{min: "1950-05-01", max: "2023-05-04"}}/>
                        </div>
                        <div>
                            <RedditTextField required variant='filled' label='Контактный номер' value={values.textmask}
                                             InputLabelProps={{shrink: true}} onChange={handleChange1} name='textmask'
                                             id='formatted-text-mask-input'
                                             InputProps={{inputComponent: TextMaskCustom, disableUnderline: true}}/>
                        </div>
                        <div>
                            <RedditTextField variant='filled' name='contract' id='contract' value={values.contract}
                                             onChange={handleChange} InputLabelProps={{shrink: true}}
                                             label='Номер кредитного договора'/>
                        </div>
                        <ButnotP type='submit' id='ButnotP3'
                                 name={debtLoading ? (
                                     <Spinner animation="border" style={{marginTop: '6px'}}/>
                                 ) : (
                                     <span>Продолжить</span>
                                 )}
                                 style={{width: '200px', height: '59px', fontSize: '12pt', borderRadius: '5px'}}/>
                    </form>

                    <div className='PrivacyRow1'>
                        <ScrollDialog checked={checked} setChecked={setChecked} id='DebtCheck'/>
                        <Form.Check type='checkbox' id='check-api-consent'>
                            <Form.Check.Input
                                type='checkbox'
                                id='check-api-c'
                                defaultChecked={checked2}
                                onClick={() => setChecked2(!checked2)}
                                isValid
                                style={{maxWidth: '24px', maxHeight: '24px', marginTop: '0px'}}
                            />
                            <Form.Check.Label>
                                <p className="Policy" onClick={() => window.open(consentPdf, '_blank')}>
                                    Я даю согласие на обработку персональных данных
                                </p>
                            </Form.Check.Label>
                        </Form.Check>
                        <span>{debtError}</span>
                    </div>

                    {/* Модальное окно — кнопки рендерятся динамически по наличию ссылок */}
                    <Modal
                        show={showModal}
                        onHide={() => setShowModal(false)}
                        centered
                        backdrop="static"
                        dialogClassName="debt-modal"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Выберите способ связи</Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>

                            {/* Всегда есть */}
                            <button
                                className="debt-modal-btn debt-modal-btn-call"
                                onClick={handleCallbackSubmit}
                            >
                                Заказать звонок
                            </button>

                            Только если API вернул ссылку на Telegram
                            {telegramUrl && (
                                <button
                                    className="debt-modal-btn debt-modal-btn-tg"
                                    onClick={() => handleLinkRedirect(telegramUrl)}
                                >
                                    Перейти в Телеграм
                                </button>
                            )}

                            {/* Только если API вернул ссылку на MAX */}
                            {maxUrl && (
                                <button
                                    className="debt-modal-btn debt-modal-btn-max"
                                    onClick={() => handleLinkRedirect(maxUrl)}
                                >
                                    Перейти в MAX
                                </button>
                            )}

                        </Modal.Footer>
                    </Modal>
                </div>
            ) : (
                <div className='debtMessage' style={debtSuccess ? {opacity: '1'} : {opacity: '0'}}>
                    <MdOutlineDone className='debtIcon'/>
                    {debtSuccess}
                    <button type='button' id='debtButtonBack' onClick={handleBackClick}>Вернуться назад</button>
                </div>
            )}
        </div>
    )
}